import React from 'react';

type Props = {
    readonly pool: number;
    readonly value: number;
    readonly onBallClick: Function;
    readonly selected: boolean;
};

function Ball({ pool, value, onBallClick, selected }: Props) {

    function getContent() {
        return (
            <div onClick={() => onBallClick(pool, value)}
                 className={'number text-center purchase-line-number purchase-line-chooseable ball ' + (selected ? 'choosed' : '')}>
                {/*<?php if (isset($old_lines[$i]) && in_array($j, $old_lines[$i][0])): echo ' choosed'; endif; ?>*/}
                {value}
            </div>
        );
    }

    return getContent();
}

export default Ball;
